import {
  login,
  logout,
  changePwd,
  getMessage,
  getContentByMsgId,
  hasRead,
  removeReaded,
  restoreTrash,
  getUnreadCount
} from '@/api/user'

import { setToken, getToken, localSave, localRead, setTagNavListInLocalstorage, getLocalAccess, setLocalAccess } from '@/libs/util'
export const CURRENT_USER_ID = 'CURRENT_USER_ID'
export const CURRENT_USER_NAME = 'CURRENT_USER_NAME'
export const CURRENT_OPERATION_USER_ID='CURRENT_OPERATION_USER_ID'
export const CURRENT_OPERATION_USER_TYPE='CURRENT_OPERATION_USER_TYPE'
export const CURRENT_REGIONAL_OPERATOR_ID = 'CURRENT_REGIONAL_OPERATOR_ID'
export const CURRENT_TEAM_LEADER_ID = 'CURRENT_TEAM_LEADER_ID'
export default {
  state: {
      userName: localRead(CURRENT_USER_NAME),
      userId: localRead(CURRENT_USER_ID),
      operationalUserId: localRead(CURRENT_OPERATION_USER_ID), // 运营用户ID
      operationalUserType: localRead(CURRENT_OPERATION_USER_TYPE), // 运营用户类型
      regionalOperatorId: localRead(CURRENT_REGIONAL_OPERATOR_ID), // 城市中心ID
      teamLeaderId: localRead(CURRENT_TEAM_LEADER_ID), // 区域运营商ID
      avatarImgPath: '',
      token: getToken(),
      access: getLocalAccess(),
      hasGetInfo: false,
      userInfo: null,
      unreadCount: 0,
      messageUnreadList: [],
      messageReadedList: [],
      messageTrashList: [],
      messageContentStore: {},
      roles: []
  },
  mutations: {
      setUserInfo(state, user) {
          state.userInfo = user
      },
      setAvatar(state, avatarPath) {
          state.avatarImgPath = avatarPath
      },
      setUserId(state, id) {
          state.userId = id
          localSave(CURRENT_USER_ID, id)
      },
      setOperationalUserId(state, id) {
        state.operationalUserId = id
        localSave(CURRENT_OPERATION_USER_ID, id)
      },
      setOperationalUserType(state, type) {
        state.operationalUserType = type
        localSave(CURRENT_OPERATION_USER_TYPE, type)
      },
      setRegionalOperatorId(state, id) {
        state.regionalOperatorId = id
        localSave(CURRENT_REGIONAL_OPERATOR_ID, id)
      },
      SetTeamLeaderId(state, id) {
        state.teamLeaderId = id
        localSave(CURRENT_TEAM_LEADER_ID, id)
      },
      setUserName(state, name) {
          state.userName = name
          localSave(CURRENT_USER_NAME, name)
      },
      setIsGeneral(state, name) {
          state.isGeneral = name
          localSave('isGeneral', name)
      },
      setToken(state, token) {
          state.token = token
          setToken(token)
      },
      setAccess(state, access) {
        state.access = access
        setLocalAccess(access)
       // localSave('access', access)
      },
      setLocalAccess(state, access) {
        state.access = access
        localSave('access', access)
      },

      setLocalRoles(state, roles) {
        state.roles = roles
        localSave('roles', JSON.stringify(roles))
      },
  
      refreshAccess(state) {
        state.access = getLocalAccess()
      },
      setHasGetInfo(state, status) {
          state.hasGetInfo = status
      },
      setMessageCount(state, count) {
          state.unreadCount = count
      },
      setMessageUnreadList(state, list) {
          state.messageUnreadList = list
      },
      setMessageReadedList(state, list) {
          state.messageReadedList = list
      },
      setMessageTrashList(state, list) {
          state.messageTrashList = list
      },
      updateMessageContentStore(state, { msg_id, content }) {
          state.messageContentStore[msg_id] = content
      },
      moveMsg(state, { from, to, msg_id }) {
          const index = state[from].findIndex(_ => _.msg_id === msg_id)
          const msgItem = state[from].splice(index, 1)[0]
          msgItem.loading = false
          state[to].unshift(msgItem)
      }
  },
  getters: {
      messageUnreadCount: state => state.messageUnreadList.length,
      messageReadedCount: state => state.messageReadedList.length,
      messageTrashCount: state => state.messageTrashList.length,
      currentUserType: (state) => {
          if (state.userInfo) {
              return state.userInfo.userType
          } else {
              return window.localStorage.getItem('userType')
          }
      }
  },
  actions: {
      handleLogin({ commit }, { username, password, loginType }) {
          return new Promise((resolve, reject) => {
              login({ username, password, loginType }).then(res => {
                  if (res.data.success) {
                      const data = res.data.data
                      commit('setToken', data.access_token)
                      commit('setUserName', data.username)
                      commit('setUserId', data.userId)
                      commit('setAccess', data.codes)
                     // commit('setLocalAccess', data.permissionCode)
                      commit('setHasGetInfo', true)
                      commit('setLocalRoles', data.operationalUserId)
                      commit('setOperationalUserId', data.operationalUserId || 0)
                      commit('setOperationalUserType', data.operationalUserType || 'admin')
                      commit('setRegionalOperatorId', data.operationalUserType ? (data.regionalOperatorId || data.operationalUserId) : 0)
                      commit('SetTeamLeaderId', data.operationalUserType==='teamLeader' ? (data.teamLeaderId || data.operationalUserId) : 0) 
                     // commit('setIsGeneral', data.isGeneral)
                    //  var jwt = require('jsonwebtoken')
                   //   var dataType = jwt.decode(data.token)
                    //  window.localStorage.setItem('userType', dataType.data.userType)
                     // window.localStorage.setItem('agentId', data.agentId)
                     // window.localStorage.setItem('opMan', data.name)
                     // window.localStorage.setItem('ManageArea', JSON.stringify(data.magementAreas))
                      window.localStorage.setItem('Roles', JSON.stringify(data.codes))
                      window.localStorage.setItem('Keys', JSON.stringify(data.bizKeys))
                    //  Object.assign(data, dataType.data)
                      commit('setUserInfo', data)
                      resolve()
                  } else {
                      reject(res.data.msg || res.data.message)
                  }
              }).catch(err => {
                  reject(err)
              })
          })
      },

      handleResetPassword({ commit }, { originPassword, newPassword }) {
        return new Promise((resolve, reject) => {
            changePwd({ originPassword, newPassword }).then(res => {
                if (res.data.success) { 
                    resolve()
                } else {
                    reject(res.data.message)
                }
            }).catch(err => {
                reject(err)
            })
        })
    },

      // �˳���¼
      handleLogOut({ state, commit }) {
          return new Promise((resolve, reject) => {
              commit('setToken', '')
              commit('setAccess', [])
              commit('setLocalRoles', [])
              setTagNavListInLocalstorage([])
              resolve()
          })
      },
      // �˷���������ȡδ����Ϣ�������ӿ�ֻ������ֵ����������Ϣ�б�
      getUnreadMessageCount({ state, commit }) {
          getUnreadCount().then(res => {
              const { data } = res
              commit('setMessageCount', data)
          })
      },
      // ��ȡ��Ϣ�б������а���δ�����Ѷ�������վ�����б�
      getMessageList({ state, commit }) {
          return new Promise((resolve, reject) => {
              getMessage().then(res => {
                  const { unread, readed, trash } = res.data
                  commit('setMessageUnreadList', unread.sort((a, b) => new Date(b.create_time) - new Date(a.create_time)))
                  commit('setMessageReadedList', readed.map(_ => {
                      _.loading = false
                      return _
                  }).sort((a, b) => new Date(b.create_time) - new Date(a.create_time)))
                  commit('setMessageTrashList', trash.map(_ => {
                      _.loading = false
                      return _
                  }).sort((a, b) => new Date(b.create_time) - new Date(a.create_time)))
                  resolve()
              }).catch(error => {
                  reject(error)
              })
          })
      },
      // ���ݵ�ǰ�������Ϣ��id��ȡ����
      getContentByMsgId({ state, commit }, { msg_id }) {
          return new Promise((resolve, reject) => {
              let contentItem = state.messageContentStore[msg_id]
              if (contentItem) {
                  resolve(contentItem)
              } else {
                  getContentByMsgId(msg_id).then(res => {
                      const content = res.data
                      commit('updateMessageContentStore', { msg_id, content })
                      resolve(content)
                  })
              }
          })
      },
      // ��һ��δ����Ϣ���Ϊ�Ѷ�
      hasRead({ state, commit }, { msg_id }) {
          return new Promise((resolve, reject) => {
              hasRead(msg_id).then(() => {
                  commit('moveMsg', {
                      from: 'messageUnreadList',
                      to: 'messageReadedList',
                      msg_id
                  })
                  commit('setMessageCount', state.unreadCount - 1)
                  resolve()
              }).catch(error => {
                  reject(error)
              })
          })
      },
      // ɾ��һ���Ѷ���Ϣ������վ
      removeReaded({ commit }, { msg_id }) {
          return new Promise((resolve, reject) => {
              removeReaded(msg_id).then(() => {
                  commit('moveMsg', {
                      from: 'messageReadedList',
                      to: 'messageTrashList',
                      msg_id
                  })
                  resolve()
              }).catch(error => {
                  reject(error)
              })
          })
      },
      // ��ԭһ����ɾ����Ϣ���Ѷ���Ϣ
      restoreTrash({ commit }, { msg_id }) {
          return new Promise((resolve, reject) => {
              restoreTrash(msg_id).then(() => {
                  commit('moveMsg', {
                      from: 'messageTrashList',
                      to: 'messageReadedList',
                      msg_id
                  })
                  resolve()
              }).catch(error => {
                  reject(error)
              })
          })
      }
  }
}